import React from 'react';
import { X, Play, Plus, Award, MapPin, Calendar } from 'lucide-react';
import { Dialog, DialogContent } from './ui/dialog';

const ProjectModal = ({ project, open, onClose }) => {
  if (!project) return null;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl bg-[#181818] border-0 p-0 overflow-hidden max-h-[90vh] overflow-y-auto">
        <div className="relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-50 w-10 h-10 bg-[#181818] rounded-full flex items-center justify-center hover:bg-gray-800 transition"
          >
            <X size={24} className="text-white" />
          </button>

          <div className="relative aspect-video w-full">
            <img
              src={project.image}
              alt={project.company}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#181818] via-transparent to-transparent" />
            
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                {project.company}
              </h1>
              <div className="flex items-center space-x-4">
                <button className="flex items-center space-x-2 bg-white text-black px-6 py-2 rounded font-semibold hover:bg-white/90 transition">
                  <Play size={20} fill="black" />
                  <span>View Portfolio</span>
                </button>
                <button className="flex items-center space-x-2 bg-gray-500/50 text-white px-6 py-2 rounded font-semibold hover:bg-gray-500/70 transition">
                  <Plus size={20} />
                  <span>Add to List</span>
                </button>
              </div>
            </div>
          </div>

          <div className="p-8 space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="flex items-center space-x-2 text-gray-300">
                <Calendar size={18} className="text-[#E50914]" />
                <span className="text-sm">{project.duration}</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300">
                <MapPin size={18} className="text-[#E50914]" />
                <span className="text-sm">{project.location}</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300">
                <Award size={18} className="text-[#E50914]" />
                <span className="text-sm font-semibold text-green-400">Active</span>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-white mb-3">{project.role}</h2>
              <p className="text-gray-300 text-base leading-relaxed">
                {project.description}
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-white mb-3">Key Achievements</h3>
              <ul className="space-y-2">
                {project.achievements.map((achievement, index) => (
                  <li key={index} className="flex items-start space-x-2">
                    <span className="text-[#E50914] mt-1">•</span>
                    <span className="text-gray-300">{achievement}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-white mb-3">Technologies & Skills</h3>
              <div className="flex flex-wrap gap-2">
                {project.technologies.map((tech, index) => (
                  <span
                    key={index}
                    className="px-4 py-2 bg-gray-700 text-white rounded-full text-sm font-medium hover:bg-gray-600 transition"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProjectModal;